var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMaximizeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 16.125v6.75C0 23.498.502 24 1.125 24h6.75a1.127 1.127 0 0 0 .797-1.922L6.844 20.25l4.078-4.078c.22-.22.328-.506.328-.797 0-.29-.108-.577-.328-.797l-1.5-1.5a1.117 1.117 0 0 0-.797-.328c-.29 0-.577.108-.797.328L3.75 17.156l-1.828-1.828A1.127 1.127 0 0 0 0 16.125Z",
  opacity: 0.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22.875 0h-6.75a1.127 1.127 0 0 0-.797 1.922l1.829 1.828-4.079 4.078a1.12 1.12 0 0 0 0 1.59l1.5 1.5c.441.44 1.154.44 1.59 0l4.078-4.079 1.828 1.828a1.127 1.127 0 0 0 1.922-.797V1.12c0-.623-.502-1.125-1.125-1.125l.004.005Z"
})));
export default SvgMaximizeIcon;